module.exports = __webpack_public_path__ + "img/ic.bdc9877c.svg";